module.exports = __webpack_public_path__ + "bg_black.jpg?878194ff09725fe23e1f391e28a3d719";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/bg_black.jpg
// module id = 7
// module chunks = 0